module.exports = new __parcel__URL__("step_two_vector_light.ede3342e.png").toString();